import  { createApp } from "vue";
import DescriptionContainer from "../Description/DescriptionContainer.vue";
import SongComments from "./SongComments.vue";
import CKEditor from '@ckeditor/ckeditor5-vue';
import naja from "naja"
import SongLyrics from "./SongLyrics.vue";
import InputHider from "../InputHider";
import { initializeArtistSelects } from "../TomSelect/selects";
import { initLockScreen } from "../LockScreen";
import { getUserIdentity } from "../helpers/User";
import { initFlatPickr } from "../Flatpickr";
import { initializeAlbumSelects } from "../TomSelect/selects";
import { addView } from "../View";
import ReportContainer from "../Report/ReportContainer.vue";


naja.initialize();
initLockScreen();
addView();
InputHider();
initFlatPickr();
initializeArtistSelects();
initializeAlbumSelects();
initReports();

function initReports() {
	const reports = document.querySelectorAll('[data-vue-report]');
	reports.forEach(report => createApp(ReportContainer).mount(report));
}

getUserIdentity().then(user => {
	createApp(SongLyrics).provide('user', user.data).provide('loginUrl', window.loginUrl).use(CKEditor).mount(
		document.querySelector('[data-vue-song-lyrics]')
	);

	createApp(DescriptionContainer).provide('user', user.data).use(CKEditor).mount(
		document.querySelector('[data-vue-song-id]')
	);

	document.querySelectorAll('[data-vue-song-comments]').forEach(songCommentElement =>
		createApp(SongComments).provide('user', user.data).use(CKEditor).mount(songCommentElement)
	);
});

naja.addEventListener('complete', e => {
	initFlatPickr();
	InputHider();
	initializeArtistSelects();
	initializeAlbumSelects();
	initReports();
});
